import { HandySvg } from 'handy-svg';
import { useState, useEffect } from "react";
import iconPointerLeft from '../../assets/icons/svg-sprite/point-arrow-left.svg';
import iconCross from '../../assets/icons/svg-sprite/close-cross--small.svg';
import iconAttention from '../../assets/icons/svg-sprite/attention.svg';
import { Link } from 'react-router-dom';
import Aside from '../../components/aside/Aside';
import { user } from "../../lib/api/api";
import closeBanner from '../../modules/close-banner';
import fixedMessage from '../../modules/fixed-message';

const ChangePassword = ({ message, setMessage }) => {
    const [errors, setErrors] = useState({});

    useEffect(() => {
        submitForm();
        closeBanner();
        fixedMessage();
    }, []);

    function submitForm() {
        const formElement = document.getElementById('passwordForm')
        formElement.addEventListener('submit', (e) => {
            e.preventDefault();
            const formData = new FormData(formElement);
            const banner = document.getElementById('messageBanner');
            user.changePassword(formData.get('password_current'), formData.get('password'), formData.get('password_confirmation'))
                .then((res) => {
                    if (res.error) {
                        setErrors(res.reason);
                        banner.style.display = 'none';
                    } else {
                        setErrors({});
                        formElement.reset();
                        banner.style.removeProperty('display');
                        setMessage('Пароль успешно изменён!');
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        });
    }

    return (
        <>
            <div className="content__article-wrap">
	            <article className="step-process-article">
		            <div className="step-process-article__inner content-columns page-container">
			            <div className="step-process-article__main content-columns__main js-section">
                            <div className="cart__header">
                                <div className="cart__header-inner">
                                    <Link className="cart__return" to='/'>
                                        <HandySvg className="svg-icon cart__return-icon" src={iconPointerLeft} width="18" height="10"/>
                                        <span className="cart__return-text">Вернуться на главную</span>
                                    </Link>
                                    <h1 className="cart__title title title--h2">Изменение пароля</h1>
                                </div>
                            </div>
                            <div className="wysiwyg">
                                <p style={{marginBottom: 30}}>После изменения пароля потребуется выполнить вход на всех устройствах, где ранее вы были авторизованы.</p>
                            </div>
                            <form method="POST" id="passwordForm">
                                <div className="form__line">
                                    <div className="form__item form__item">
                                        <input id="password_current" className={'input input--md js-focus-outside' + (errors.password_current ? ' has-error' : '')} type="password" name="password_current" placeholder="Текущий пароль"/>
                                        <div className="personal-form__error-message form__error active">{errors.password_current ? errors.password_current.map(item => (`${item}`)).join('') : ''}</div>
                                    </div>
                                </div>
                                <div className="form__line">
                                    <div className="form__item form__item--md">
                                        <input id="password" className={'input input--md js-focus-outside' + (errors.password ? ' has-error' : '')} type="password" name="password" placeholder="Новый пароль"/>
                                        <div className="personal-form__error-message form__error active">{errors.password ? errors.password.map(item => (`${item}`)).join('') : ''}</div>
                                    </div>
                                    <div className="form__item form__item--md">
                                        <input id="password_confirmation" className={'input input--md js-focus-outside' + (errors.password_confirmation ? ' has-error' : '')} type="password" name="password_confirmation" placeholder="Повторите новый пароль"/>
                                        <div className="personal-form__error-message form__error active">{errors.password_confirmation ? errors.password_confirmation.map(item => (`${item}`)).join('') : ''}</div>
                                    </div>
                                </div>
                                <div className="form__line">
                                    <button className="solid-btn solid-btn--md solid-btn--blue bttn" type="submit">Изменить пароль</button>
                                </div>
                            </form>
                            <div id='messageBanner' className="info-cards__message-container js-closing-banner js-fixed-message" style={{display: 'none'}}>
                                <div className="info-cards__message">
                                    <div className="info-cards__message-content">
                                        <HandySvg className="svg-icon" src={iconAttention} width="36" height="36"/>
                                        <div className="info-cards__message-text">{message}</div>
                                    </div>
                                    <button className="js-close-btn info-cards__message-btn" type="button">
                                        <HandySvg className="svg-icon" src={iconCross} width="13" height="12"/>
                                    </button>
                                </div>
                            </div>
			            </div>
                        <aside className="common-article__aside content-columns__aside" style={{marginTop: 50}}>
                            <div className="content-columns__aside-cell">
                                <Aside/>
                            </div>
		                </aside>
                    </div>
	            </article>
            </div>
        </>
    );
};

export default ChangePassword;